export let ChatMessageType = /*#__PURE__*/function (ChatMessageType) {
  ChatMessageType["GOOGLE_MEET"] = "google-meet";
  ChatMessageType["FILE"] = "file";
  ChatMessageType["SCHEDULED"] = "scheduled";
  ChatMessageType["QUESTION"] = "question";
  return ChatMessageType;
}({});
export let ChatMessageMenu = /*#__PURE__*/function (ChatMessageMenu) {
  ChatMessageMenu["REPLY"] = "reply";
  ChatMessageMenu["ANNOUNCE"] = "announce";
  ChatMessageMenu["EDIT"] = "edit";
  ChatMessageMenu["DELETE"] = "delete";
  return ChatMessageMenu;
}({});
export let ScheduledMessageFormKey = /*#__PURE__*/function (ScheduledMessageFormKey) {
  ScheduledMessageFormKey["RECIPIENT"] = "recipient";
  ScheduledMessageFormKey["MESSAGE"] = "message";
  ScheduledMessageFormKey["FILE"] = "file";
  ScheduledMessageFormKey["SCHEDULED_AT"] = "scheduledAt";
  return ScheduledMessageFormKey;
}({});